(function () {
  function getParam(name) {
    return new URLSearchParams(window.location.search).get(name);
  }

  class MembershipResumeCard extends HTMLElement {
    connectedCallback() {
      var handle = getParam('handle');
      var pid = getParam('pid');

      // Save for a later visit (e.g. after checkout) even if we can't render
      // the card right now.
      try {
        if (pid) localStorage.setItem('crazytall_resume_pid', pid);
        if (handle) localStorage.setItem('crazytall_resume_handle', handle);
      } catch (e) {
        /* localStorage unavailable — ignore */
      }

      if (!handle) return; // No handle: render nothing, leave [hidden] in place.

      var cardEl = this.querySelector('.membership-resume-card__card');

      fetch('/products/' + encodeURIComponent(handle) + '?view=member-card')
        .then(function (response) {
          if (!response.ok) throw new Error('Product lookup failed');
          return response.text();
        })
        .then(
          function (html) {
            cardEl.innerHTML = html;
            this.hidden = false;
          }.bind(this)
        )
        .catch(function () {
          /* Product not found or fetch failed — leave the section hidden. */
        });
    }
  }

  customElements.define('membership-resume-card', MembershipResumeCard);
})();
